<template>
  <div class="profile" @click="closeModal($event)">
    <div class="profile-data-container">
      <div class="profile-banner">
        <div class="profile-banner-options">
          <div class="back-btn" @click="backToHome()"></div>
          <span class="profile-tag">@ashley9x </span>
          <div class="follow-btn"></div>
        </div>
        <div class="profile-picture"></div>
      </div>
      <div class="profile-information">
        <div class="profile-details">
          <div class="followers"><span>1.2k</span><span>Abonnenten</span></div>
          <div class="name">Ashley</div>
          <div class="contributors"><span>20</span><span>Beiträge</span></div>
        </div>
        <div class="profile-options">
          <div class="share"></div>
          <div class="suscribe" @click="suscribe_button_press($event)" v-bind:style="{backgroundColor: suscribeStatus}" ></div>
          <div class="chat"></div>
        </div>
        <div class="profile-bio">I like to travel, do sport and just having a good time!</div>
      </div>
    </div>
    <div class="catalogue">
      <div class="row">
        <div class="column"><div class="image-frame"><span class="likes">120.0k</span><img src="../assets/post1.png"/></div></div>
        <div class="column"><div class="image-frame"><span class="likes">153.1k</span><img src="../assets/post2.png"/></div></div>
      </div>
      <div class="row">
        <div class="column"><div class="image-frame"><span class="likes">117.9k</span><img src="../assets/post3.png"/></div></div>
        <div class="column"><div class="image-frame"><span class="likes">99.3k</span><img src="../assets/post4.png"/></div></div>
      </div>
      <div class="row">
        <div class="column"><div class="image-frame"><span class="likes">101.5k</span><img src="../assets/post5.png"/></div></div>
        <div class="column"><div class="image-frame"><span class="likes">70.8k</span><img src="../assets/post6.png"/></div></div>
      </div>
    </div>
    <div id="myModal" v-bind:style="{display: modalstatus}"  class="modal">
      <!-- Modal content -->
      <div class="modal-content">
        <div class="modal-header">
          <span></span>
          <span>Abonnement</span>
          <span @click="closeModal($event)" id="close" class="close">&times;</span>
        </div>
        <div class="modal-body">
          <span>Abonniere mich und erhalte folgende Vorteile.</span>
          <ul>
            <li><span>kostenloser Zugriff auf alle meine SecretPics & Vids</span></li>
            <li><span>Exklusive Pics & Vids (nur für Abonnenten)</span></li>
            <li><span>20 kostenlose Chatnachrichten pro Monat</span></li>
          </ul>
        </div>
        <div class="modal-bottom">
          <span class="confirmSuscribe" @click="confirmSuscription()">Jetzt abonnieren</span>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "Profile",
      data: function () {
        return {
          modalstatus : "none",
          suscribeStatus : "#C7636F"
        }
      },
      methods: {
        backToHome() {
          this.$router.push('/');
        },
        suscribe_button_press(e){
          this.modalstatus = "block";
          e.stopPropagation(); // Prevent bubbling
        },
        closeModal(event){
          event.stopPropagation();
          if(this.modalstatus === "block" && (event.target.id === "myModal" || event.target.id === "close")){
            this.modalstatus = "none";
          }
        },
        confirmSuscription(){
          this.suscribeStatus = "#918FFD";
          this.modalstatus = "none";
        }
      }
    }
</script>

<style scoped>
  * {
    font-family: "Helvetica";
  }
  .profile{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .profile-data-container{
    width: 100%;
    height: 45%;
    background-color: white;
  }

  .profile-banner{
    background-image: url("../assets/profile-banner1.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50%;
  }
  .profile-banner-options{
    display: flex;
    justify-content: space-between;
    margin-top: 3vw;
    align-items: center;
    width: 100%;
    height: 30%;
  }
  .back-btn{
    background-image: url("../assets/back-icon.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    background-size: 45%;
    width: 12vw;
    height: 12vw;
    margin-left: 3vw;
    background-color: rgba(166,166,166,0.8);
    border-radius: 50%;
  }
  .profile-tag{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25%;
    height: 100%;
    font-weight: bold;
    color: white;
    text-shadow: 1px 2px rgba(0,0,0,0.7);
  }
  .follow-btn{
    background-image: url("../assets/profile-icon.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    background-size: 50%;
    width: 12vw;
    height: 12vw;
    margin-right: 3vw;
    background-color: rgba(166,166,166,0.8);
    border-radius: 50%;
  }
  .profile-picture{
    background-image: url("../assets/profile1.png");
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: -7vw;
    z-index: 1;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    border: 4px solid white;
  }
  .profile-information{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 50%;
  }
  .profile-details{
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #445157;
    width: 100%;
    height: 35%;
  }
  .followers{
    width: 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .name{
    color:#C7636F;
    font-weight: bold;
    margin-top: 4.5vw;
  }
  .contributors{
    width: 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .profile-options{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 45%;
    background-color: white;
  }
  .share{
    background-image: url("../assets/share-icon.png");
    background-repeat: no-repeat;
    background-size: 20%;
    background-position-y: center;
    background-position-x: center;
    width: 33.3%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .suscribe{
    background-image: url("../assets/crown-icon.png");
    background-repeat: no-repeat;
    background-size: 75%;
    background-position-y: center;
    background-position-x: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15vw;
    height: 15vw;
    border-radius: 50%;
    background-color: #C7636F;
    box-shadow: 1px 5px rgba(0,0,0,0.2);
  }
  .chat{
    background-image: url("../assets/chat-icon.png");
    background-repeat: no-repeat;
    background-size: 25%;
    background-position-y: center;
    background-position-x: center;
    width: 33.3%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .profile-bio{
    display: flex;
    align-items: center;
    padding-left: 20px ;
    font-size: 1.8vh;
    width: 100%;
    height: 20%;
    color: #445157;
  }
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1vw;
    width: 100%;
    margin-bottom: 1vw;
  }

  .column {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
  }

  .image-frame {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 123%;
  }
  .image-frame img {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .likes{
    position: absolute;
    bottom: 5px;
    right: 5px;
    color: white;
    font-weight: bold;
    z-index: 1;
  }

  .modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 2; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.6); /* Black w/ opacity */
  }

  /* Modal Content */
  .modal-content {
    background-color: #C7636F;
    margin: auto;
    padding: 20px;
    border-radius: 5vw;
    width: 80%;
    color: white;
  }

  .modal-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 6vw;
    margin-bottom: 2vw;
  }
  .modal-body{
    font-size: 3.5vw
  }
  .modal-body ul li{
    position: relative;
    left: -15px;
  }
  .modal-bottom{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4vw;
  }

  .confirmSuscribe{
    border: 1.5vw solid #ffffff;
    padding: 3vw;
    border-radius: 7vw;
    box-shadow: 1px 3px rgba(0,0,0,0.35);
  }

  /* The Close Button */
  .close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue